import React from 'react';
import { useParams } from 'react-router-dom';
import EnergyOfficialsBreadCrumb from './EnergyOfficialsBreadCrumb';
import EnergyOfficials from './EnergyOfficials';

function EnergyOfficialPage() {
    const { id } = useParams(); // Get plant ID from route

    return ( 
        <div className="container-fluid">
            <EnergyOfficialsBreadCrumb plantId={id} />
            <EnergyOfficials plantId={id} />
        </div>
    );
}

export default EnergyOfficialPage;
